module.exports = __webpack_public_path__ + "./Ning_pbw_52f1efef94928652b9ce295d5569e07f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2023/Ning_pbw.png
// module id = 605
// module chunks = 0